// Firebase 配置文件
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth } from 'firebase/auth';
import { getAnalytics, Analytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyC6Uv_pBokJ9taNfnQ7uHCFvdAEWFfc-gM",
  authDomain: "surepal-web-app-13a7a.firebaseapp.com",
  projectId: "surepal-web-app-13a7a",
  storageBucket: "surepal-web-app-13a7a.firebasestorage.app",
  messagingSenderId: "333456042550",
  appId: "1:333456042550:web:8faba130cb2763c21cc697",
  measurementId: "G-YVZLT151MR"
};

// 初始化 Firebase
const app = initializeApp(firebaseConfig);

// 初始化 Firebase 服務
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);

// 初始化 Firebase Analytics
export const analytics: Analytics | null = typeof window !== 'undefined' ? getAnalytics(app) : null;

export default app;